var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data-container",style:({marginTop: _vm.marginTop})},[_c('img',{attrs:{"src":require("@/assets/img/qietu/nodata.png"),"alt":""}}),_c('p',[_vm._v("暂无数据")])])
}
var staticRenderFns = []

export { render, staticRenderFns }